import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil, withLatestFrom } from 'rxjs/operators';

import { NO_VALUE } from '@pipes';
import { ActiveErrorsStore, RemoteDiagnosticsStore, VddDetailsListStore } from '@store';

import { RemoteDiagnosticsVddGenericStructure } from '@vi-iot/client';
import { dataAtTheTimeOfFaultDetectionVddName } from '../../guided-troubleshooting.model';
import { SemanticValues } from '../../../extended-parameters/diagnostics-constants';
import { VddDetailsListHelper } from '../../../../../../@store/vdd-details-list/vdd-details-list.helper';

@Component({
  selector: 'app-freeze-frame',
  templateUrl: './freeze-frame.component.html',
  styleUrls: ['./freeze-frame.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreezeFrameComponent implements OnInit, OnDestroy {
  NO_VALUE = NO_VALUE;
  SemanticValues = SemanticValues;
  dataAtTheTimeOfFaultDetectionLoading$: Observable<boolean>;
  gatewaySerial: string;
  isShowingMore = false;
  matchedValues: RemoteDiagnosticsVddGenericStructure[];

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private vddDetailsListStore: VddDetailsListStore,
    private activatedRoute: ActivatedRoute,
    private remoteDiagnosticsStore: RemoteDiagnosticsStore,
    private activeErrorsStore: ActiveErrorsStore
  ) {}

  ngOnInit(): void {
    this.gatewaySerial = this.activatedRoute.snapshot.queryParams.gatewaySerial;

    this.activeErrorsStore.selectedActiveError$
      .pipe(
        withLatestFrom(
          this.remoteDiagnosticsStore.getLogicalLinkOfSelectedActiveError(this.gatewaySerial)
        ),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe(([_error, logicalLinkName]) => {
        this.vddDetailsListStore.clearVdd(dataAtTheTimeOfFaultDetectionVddName, logicalLinkName); // reset any errors

        this.remoteDiagnosticsStore.openLogicalLinkBeforeVddReadingAttempt(
          this.gatewaySerial,
          logicalLinkName,
          [dataAtTheTimeOfFaultDetectionVddName]
        );
      });

    this.remoteDiagnosticsStore
      .getLogicalLinkOfSelectedActiveError(this.gatewaySerial)
      .pipe(take(1))
      .subscribe((logicalLink) => {
        this.dataAtTheTimeOfFaultDetectionLoading$ = this.vddDetailsListStore.isVddLoading(
          dataAtTheTimeOfFaultDetectionVddName,
          logicalLink
        );

        this.vddDetailsListStore
          .getVddDetail(dataAtTheTimeOfFaultDetectionVddName, logicalLink)
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe((value) => {
            this.matchedValues = VddDetailsListHelper.getMatchValues(
              VddDetailsListHelper.getFlattenedStructure(value?.structure),
              VddDetailsListHelper.getFlattenedSingleRead(value?.singleRead)
            );
          });
      });
  }

  onIsShowingMoreChange(): void {
    this.isShowingMore = !this.isShowingMore;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
